import { render, staticRenderFns } from "./AgreementView.vue?vue&type=template&id=aba8eff0&"
import script from "./AgreementView.vue?vue&type=script&lang=js&"
export * from "./AgreementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports